import queryString from 'query-string';

export enum Routes {
  ExpertManagement = '/',
  Community = '/community',
  Admin = '/admin',
  WebinarSessions = '/webinar',
}

export enum AdminRoutes {
  Permissions = '/permissions',
  PodTypeManagement = '/pod-type-management',
  System = '/system',
}

export const buildRoute = (route: Routes, searchParams?: Record<string, string>) => {
  const { spoof } = queryString.parse(location.search);
  const paramsWithSpoof = { ...(searchParams ?? {}), ...(spoof ? { spoof: spoof as string } : {}) };
  let url = removeTrailingBackslash(route.toString());
  if (Object.keys(paramsWithSpoof).length > 0) {
    const params = new URLSearchParams(
      Object.entries(paramsWithSpoof ?? {}).map(entry => [entry[0], entry[1]]),
    );
    url += '?' + params.toString();
  }
  return url;
};

export const removeLeadingBackslash = (url: string) => {
  if (url.startsWith('/')) {
    return url.slice(1);
  }
  return url;
};

export const removeTrailingBackslash = (url: string) => {
  if (url.endsWith('/')) {
    return url.slice(0, -1);
  }
  return url;
};
